import { render } from "./CommentTextfieldComponent.vue?vue&type=template&id=701b043b&ts=true"
import script from "./CommentTextfieldComponent.vue?vue&type=script&lang=ts"
export * from "./CommentTextfieldComponent.vue?vue&type=script&lang=ts"

import "./CommentTextfieldComponent.vue?vue&type=style&index=0&id=701b043b&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__